<template>
  <div class="progress-table" v-if="documents.length">
    <div class="table-head">
      <div class="serial">№</div>
      <div class="name">Назва документу</div>
      <div class="control">Завантажити</div>
    </div>
    <div class="table-row" v-for="(document, i) in documents" :key="i">
      <div class="serial">{{ i + 1 }}</div>
      <div class="name">
        {{ document.title }}
      </div>
      <div class="control">
        <a
          :href="document.url"
          target="_blank"
          class="genric-btn info-border small"
        >
          <i class="fas fa-download"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentsTable",
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
